import {gql} from '@apollo/client'

export const GET_SETTINGS_BY_ORGANIZATION = gql`
  query allSettings($organization: ID!) {
    allSettings(organization: $organization) {
      edges {
        node {
          id
          name
          value
          loginReturn
          created
        }
      }
    }
  }
`
